"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var reactstrap_1 = require("reactstrap");
var react_router_dom_1 = require("react-router-dom");
var SelectAction = /** @class */ (function (_super) {
    __extends(SelectAction, _super);
    function SelectAction(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            didSubmitAlertVisable: props.didSubmit,
            postFade: props.didSubmit
        };
        if (props.didSubmit) {
            setTimeout(function () {
                _this.setState({
                    didSubmitAlertVisable: false
                });
                setTimeout(function () { return _this.setState({ postFade: false }); }, 150);
            }, 5000);
        }
        return _this;
    }
    SelectAction.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(reactstrap_1.CustomInput, { type: "select", id: "selectAction", name: "selectAction", onChange: function (e) { return _this.props.onChangeHandler(JSON.parse(e.currentTarget.value)); } },
                React.createElement("option", { key: "selectAction", value: "", hidden: true }, this.props.resources.PleaseSelectAnAction),
                this.props.availableActions.map(function (action) {
                    return React.createElement("option", { key: action.value, value: JSON.stringify(action) }, action.displayName);
                })),
            this.props.didSubmit && this.state.postFade &&
                React.createElement(reactstrap_1.Fade, { in: this.state.didSubmitAlertVisable },
                    React.createElement(reactstrap_1.Alert, { color: "success" },
                        this.props.resources.Multiple_RequestSubmitted,
                        " ",
                        React.createElement(react_router_dom_1.Link, { to: "/Dashboard/Multiple/Queue", className: "alert-link" }, this.props.resources.Multiple_GoToStatusReport),
                        "."))));
    };
    return SelectAction;
}(React.Component));
exports.SelectAction = SelectAction;
//# sourceMappingURL=SelectAction.js.map